
// Intersection Observer for scroll animations
document.addEventListener("DOMContentLoaded", function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px -50px', threshold: 0.1 });

  document.querySelectorAll('.fade-in-section').forEach(function(el) {
    observer.observe(el);
  });
});
